/**
 * Unauthenticated client for the public complaint desk.
 *
 * Deliberately does NOT attach a JWT and does NOT bounce to /login on
 * 401 — a leftover token in localStorage must not lock a visitor out of
 * signup, and a 400 from a bad password must not trigger token refresh.
 */
import axios from 'axios';

import { apiOrigin } from '../config';

function buildBaseURL() {
  const origin = apiOrigin();
  if (origin) return `${origin}/api`;
  return '/api';
}

const publicApi = axios.create({
  baseURL: buildBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
  timeout: 30_000,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

export const PublicComplaintsAPI = {
  access: () =>
    publicApi.get('/complaints/public-access/').then((r) => r.data),
  signup: (body) =>
    publicApi.post('/complaints/public-signup/', body).then((r) => r.data),
  login: (body) =>
    publicApi.post('/complaints/public-login/', body).then((r) => r.data),
};

export default PublicComplaintsAPI;
